import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LoaderService {
    private readonly loadingSubject = new Subject<boolean>();
    private readonly loadingObservable: Observable<boolean>;

    private loadersStarted: number = 0;

    get loading(): Observable<boolean> { return this.loadingObservable; }

    constructor() {
        this.loadingObservable = this.loadingSubject.asObservable();
    }

    private setLoadingState = (state: boolean): void => { this.loadingSubject.next(state); }

    startLoading = (): void => {
        this.loadersStarted++;
        this.setLoadingState(true);
    }

    stopLoading = (): void => {
        this.loadersStarted--;
        if (this.loadersStarted < 1) {
            this.setLoadingState(false);
            if (this.loadersStarted < 0) {
                this.loadersStarted = 0;
            }
        }
    }
}